import { render, staticRenderFns } from "./ScenceTypeManagement.vue?vue&type=template&id=d9a03bde&scoped=true"
import script from "./ScenceTypeManagement.vue?vue&type=script&lang=js"
export * from "./ScenceTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./ScenceTypeManagement.vue?vue&type=style&index=0&id=d9a03bde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a03bde",
  null
  
)

export default component.exports